(function() {
    'use strict';

    angular.module('conferencesApp').controller('AdminConferencesCtrl', function($scope, Conference) {

        $scope.conferences  = Conference.query({});
    });

    angular.module('conferencesApp').controller('AdminConferencesListCtrl', function($scope) {

    });

    angular.module('conferencesApp').controller('AdminConferenceCtrl', function($scope, $stateParams, Conference) {

        $scope.conferenceId = $stateParams.conferenceId;
        $scope.conference = Conference.get({id: $scope.conferenceId}, function (conference, $stateParams, Conference) {
            $scope.title = conference.name.text;
        });

        $scope.pagination = {
            itemsPerPage: 15
        };
        $scope.filters = {
            conference: $scope.conferenceId,
            page: 1
        };

        $scope.attendeePagination = {
            itemsPerPage: 15
        };
        $scope.attendeeFilters = {
            conference: $scope.conferenceId,
            page: 1
        };
    });

    angular.module('conferencesApp').controller('AdminConferenceDetailCtrl', function($scope) {

    });

})();
